export default function isAnyOptionDirty(currentSubcategory) {
    return currentSubcategory.options.reduce(function (state, option) { return state || option.fullOptionFormSettings.isDirty(); }, false);
}
//# sourceMappingURL=isAnyOptionDirty.js.map